import Checkbox from "components/Input/Checkbox";
import { registerInput } from "../index";

export default registerInput(Checkbox);
